<template>
  <div class="pts-tour-select">
    <p v-if="sections.length > 1 && intro" class="pts-tour-select__intro">
      {{ intro }}
    </p>
    <div
      v-for="section in sections"
      :key="section.key"
      class="pts-tour-card"
      :class="{
        'pts-tour-card--selected': isSelected(section),
        'pts-tour-card--complete': isComplete(section),
      }"
      @click="onSelect(section)"
    >
      <div class="pts-tour-card__badge">
        <i class="material-icons">{{ section.icon || 'explore' }}</i>
      </div>
      <div class="pts-tour-card__info">
        <div class="pts-tour-card__name-row">
          <span class="pts-tour-card__name">{{ section.cardLabel || section.title }}</span>
          <span
            class="pts-tour-card__status"
            :class="isComplete(section) ? 'pts-status--complete' : 'pts-status--pending'"
          >
            <i class="material-icons pts-tour-card__status-icon">{{ isComplete(section) ? 'check_circle' : 'autorenew' }}</i>
            {{ isComplete(section) ? 'Completed' : 'Incomplete' }}
          </span>
        </div>
      </div>
      <div class="pts-tour-card__check">
        <span class="pts-check-ring" :class="{ 'pts-check-ring--selected': isSelected(section) }">
          <i v-if="isSelected(section)" class="material-icons pts-check-ring__icon">check</i>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
// One card per section instance the API returned: each tour, Communications &
// Information, and any future section type. Keyed on `section.key`, which is
// already de-duplicated server-side (several supplier codes can be one tour).
export default {
  props: {
    sections: { type: Array, required: true },
    completedSections: { type: Array, default: () => [] },
    selectedSection: { type: Object, default: null },
    intro: { type: String, default: '' },
  },
  methods: {
    isComplete(section) {
      return this.completedSections.includes(section.key)
    },

    isSelected(section) {
      return !!this.selectedSection && this.selectedSection.key === section.key
    },

    onSelect(section) {
      if (!this.isComplete(section)) {
        this.$emit('select', section)
      }
    },
  },
}
</script>
